import { useEffect } from "react";
import { useNavigate, useParams } from "react-router";

export const useRegistrationIdParam = (): string => {
  const { registrationId } = useParams<{ registrationId: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    if (!registrationId) {
      navigate("/");
    }
  }, [registrationId, navigate]);

  if (!registrationId) {
    throw new Error("registrationId is required but was not found in route params");
  }

  return registrationId;
};
